import { useState } from "react";

export default function CopyButton({ label, getPayload, className = "", disabled }) {
  const [status, setStatus] = useState("idle");

  async function handleCopy() {
    if (disabled) {
      return;
    }

    try {
      setStatus("copying");
      await getPayload();
      setStatus("copied");
      window.setTimeout(() => setStatus("idle"), 1800);
    } catch (error) {
      setStatus("error");
      window.setTimeout(() => setStatus("idle"), 2200);
    }
  }

  const resolvedLabel =
    status === "copied" ? "Copied" : status === "error" ? "Copy failed" : label;

  return (
    <button
      type="button"
      className={className}
      disabled={disabled || status === "copying"}
      onClick={handleCopy}
    >
      {resolvedLabel}
    </button>
  );
}

